<template>
  <div>
    <div v-if="scriptParsed" class="script">
      <p v-html="scriptParsed"></p>
    </div>
    <el-tabs v-model="activeForm" v-if="haveForms">
      <el-tab-pane v-for="(form, index) in forms" :key="form.key" :label="form.name | utf8" :name="index.toString()">
        <Form :form="{ ...form, idCall, callKey: activityKey }" @submit="submitForm" :path="getFormPath(form.key)"></Form>
      </el-tab-pane>
    </el-tabs>
    <div v-if="!haveForms">
      <img src="@/img/undraw_phone_call_re_hx6a.svg" v-if="isInCall" />
      <img src="@/img/undraw_join_re_w1lh.svg"  v-else />
    </div>
  </div>
</template>

<script>
import Form from "@/components/agent-console/Form";
export default {
  props : {
    activityKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeForm: "0"
    }
  },
  components :{
    Form
  },
  computed:{
    call(){
      return this.$store.getters['agentConsoleCall/getActiveActivityCall'] ?? {};
    },
    scriptParsed() {
      if (!this.call.script) {
        return "";
      }

      return this.call.script
        .replace(/<style type="text\/css">.*<\/style>/g, "")
        .replace(/<style type="text\/css">(.*\t*\n*)+<\/style>/, "")
        .replace("background: #FFF;", "");
    },
    forms() {
      return this.call.forms ?? []
    },
    isInCall() {
      return this.$store.getters['getIsInCall']
    },
    agent() {
      return this.$store.getters['getAgent']
    },
    idCall() {
      return this.call.id_call
    },
    formPath() {
      return `organization/${this.agent.organization_id}/calls/${this.activityKey}/forms`
    },
    haveForms() {
      return this.forms.length > 0
    }
  },
  methods: {
    getFormPath(formKey) {
      return `${this.formPath}/${formKey}`
    },
    submitForm(form) {
      const data = {
        id_call : form.idCall,
        form : form.inputs,
        call_type : form.type,
        call_key : this.activityKey,
        form_key : form.key
      }
      this.$store.dispatch('saveForm', data).then(() => {
        this.$store.dispatch('setFormStatusToActive', this.getFormPath(form.key))
      })
    },
  }
}
</script>

<style scoped>
img {
  width: 20em;
  display: block;
  margin: 0 auto;
}
</style>